<template>
  <div class="subscribe">
    <headers class="herderNav" ref="header" :isChange="false" />
    <div class="subsriCon">
      <div class="subsriConCard">
        <h1>活动信息</h1>
        <div class="cardText">
          <div class="cardTextLeft">
            <el-image :src="base + openClassInfo.avatar_url"></el-image>
          </div>
          <div class="cardTextRight">
            <div class="textCenter">
              <p class="firstText">{{ openClassInfo.description }}</p>
              <p class="secondText">
                <span>主讲老师：<a>{{openClassInfo.teacher_name}}</a></span>
                <span>活动时间：<a>{{openClassInfo.date+" "+openClassInfo.time}}</a></span>
              </p>
            </div>
          </div>
        </div>
        <div class="left">
          <h1 class="tit" @click="toggle=false">填写微信号</h1>
          <p class="tipsText">主讲老师与同学们的沟通将在微信群内进行，请务必填写正确的微信号或微信绑定的手机号</p>
          <div class="binding">
            <input type="text" v-model="phoneVal" placeholder="填写微信号" />
            <button @click="makeAppoint">提交预约</button>
          </div>
        </div>
        <div class="line"><div>or</div><div></div></div>
        <div class="right_item">
          <h1 class="rightTit" @click="toggle=true">扫码添加小助手</h1>
          <p class="tipsText">
            <span>扫码添加小助手微信,即刻成功报名。</span>
            <span>小助手微信号: jjgmat780/jjgmat800</span>
          </p>
          <div class="subBtns">
            <div class="right">
              <div>
                <div>
                  <div><img src="@/assets/rightNav/vico.jpg" alt=""></div>
                  <div style="width: 85px;">小助手(vico)</div>
                </div>
                <div>
                  <div><img src="@/assets/rightNav/zhushou.jpg" alt=""></div>
                  <div style="width: 85px;">小助手(江流儿)</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import api from "@/api/openClass.js";
  import baseUrl from "@/api/common.js";
  import $ from 'jquery'
  import headers from "@/components/header.vue";
  export default {
    components: {
      headers,
    },
    data() {
      return {
        toggle: true,
        navCodes: require("@/assets/login/navCode.png"),
        herderTits: {
          color: "#666666",
        },
        headerIcon: require("@/assets/home/headerNav.png"),
        classInfo: {},
        phoneVal: "",
        openClassInfo: {},
        base:baseUrl
      };
    },
    mounted() {
      this.$refs.header.isTop = false
      this.$refs.header.headerBack.background = '#ffffff';
      this.$refs.header.herderTits.color = '#666666';
      this.$refs.header.headerIcon = require('@/assets/home/headerNav.png');
      this.$refs.header.loginButton = {
        background: '#618aff',
        color: '#fff'
      }
      this.$refs.header.phoneButton = {
        color: '#618aff',
        border: '1px solid #618aff'
      }
      this.getData();
      $('html,body').scrollTop(0);
      // console.log($('html,body'))
    },
    methods: {
      //获取数据
      getData() {
        let params = {
          id: this.$route.params.id,
          type: this.$route.params.name,
        };
        let query = this.$qs.stringify(params);
        api.subDetails(query).then((res) => {
          this.classInfo = res.data.data;
          console.log(this.classInfo);
          let idx = this.$route.params.idx;
          let type = this.$route.params.name;
          console.log(type);
          if (type === 'free') {
            let freeList = sessionStorage.getItem("freeList");
            freeList = JSON.parse(freeList);
            console.log(freeList);
            this.openClassInfo = freeList[idx];
            this.openClassInfo.description = freeList[idx].title;
            console.log(this.openClassInfo);
          } else if (type === 'open') {
            let openClassList = sessionStorage.getItem("openClassList");
            openClassList = JSON.parse(openClassList);
            console.log(openClassList);
            this.openClassInfo = openClassList[idx];
          }
        });
      },
      //预约
      makeAppoint() {
        if (this.phoneVal) {
          let params = {
            id: this.$route.params.id,
            phone: this.phoneVal,
            type: this.$route.params.name,
          };
          let query = this.$qs.stringify(params);
          api.subscribe(query).then((res) => {
              if (res.data.code == 0) {
                this.phoneVal = "";
                console.log(res)
                this.$message.success('已预约成功，小助手会联系你')
                // this.$router.push("/openClass");
                this.$router.push("/free");
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch((err) => {
              this.$message.error("预约失败");
            });
        } else {
          this.$message.error("联系方式不能为空");
        }
      },
      timestampToTime(timestamp) {
        var date = new Date(timestamp * 1500); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
        let y = date.getFullYear();
        let MM = date.getMonth() + 1;
        MM = MM < 8 ? "0" + MM : MM;
        let d = date.getDate();
        d = d < 8 ? "0" + d : d;
        let h = date.getHours();
        h = h < 8 ? "0" + h : h;
        let m = date.getMinutes();
        m = m < 8 ? "0" + m : m;
        let s = date.getSeconds();
        s = s < 8 ? "0" + s : s;
        return y + "-" + MM + "-" + d + " " + h + ":" + m + ":" + s;
      },
    },
  };

</script>

<style scoped>
 @import '../../assets/css/subscribe.css';
</style>



// WEBPACK FOOTER //
// src/view/teacherTeam/subscribe.vue